import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AutenticacionService } from '../services/autenticacion.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private _autenticacionService: AutenticacionService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let currentUser = this._autenticacionService.getUsuario();
	  if (currentUser && currentUser.AccessToken) {
      request = request.clone({
        setHeaders: {
			  Authorization: `Bearer ${currentUser.AccessToken}`
        }
      });
    }

    return next.handle(request);
  }
}
